import { useState, useEffect } from "react";
import { organizationService } from "../services/api/organization";

export interface OrganizationData {
  name: string;
  representativeName: string;
  representativeRole: string;
}

export const useOrganizationData = (organizationId: string | null) => {
  const [data, setData] = useState<OrganizationData>({
    name: "[Organization]",
    representativeName: "[Representative Name]",
    representativeRole: "[Representative Role]",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOrg = async () => {
      if (!organizationId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await organizationService.get(organizationId);
        if (response?.data) {
          setData({
            name: response.data.name || "[Organization]",
            representativeName:
              response.data.representativeName || "[Representative Name]",
            representativeRole:
              response.data.representativeRole || "[Representative Role]",
          });
        }
      } catch (err: any) {
        console.error("Error fetching organization data:", err);
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to load organization details",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchOrg();
  }, [organizationId]);

  return { data, loading, error };
};
